export const IMAGE_FILE_MAIN_MIME_TYPES = "image/jpg, image/jpeg, image/png"

export const IMAGE_FILE_MIME_TYPES = [
  "image/bmp",
  "image/jpeg",
  "image/png",
  "image/tiff",
  "image/webp",
]

export const ATTACHMENT_IMAGE_EXTENSIONS = ["jpg", "jpeg", "png"]

export const ATTACHMENT_ALLOWED_EXTENSIONS = [
  ...ATTACHMENT_IMAGE_EXTENSIONS,
  "dwg",
  "docx",
  "pdf",
  "xlsx",
  "csv",
  "txt",
  "tsv",
]

export const DIR_ATTACHMENTS = "attachments"
export const DIR_ATTACHMENTS_UPLOAD = "uploads"

// At the time of the writing the POST and POST BATCH max file size is 100 MB
export const MAX_UPLOAD_FILE_SIZE = 100000000 // 100MB
export const MAX_UPLOAD_PROFILE_PIC_SIZE = 1000000 // 1MB

export const SFX_LOGO = "img/sfx_logo.svg"
export const SFX_WATERMARK = "img/sfx_watermark.svg"
export const SAMMY_BIG = "img/sammy_big.svg"
export const SAMMY_SMALL = "img/sammy_small.svg"

export const WORKSPACE_PLACEHOLDER_MANAGER = "img/workspacePlaceholderManager.svg"
export const WORKSPACE_PLACEHOLDER_MANAGER_BIG = "img/workspacePlaceholderManagerBig.svg"
export const WORKSPACE_PLACEHOLDER_TECHNICIAN = "img/workspacePlaceholderTechnician.svg"
export const WORKSPACE_PLACEHOLDER_TECHNICIAN_BIG = "img/workspacePlaceholderTechnicianBig.svg"
export const WORKSPACE_PLACEHOLDER_TABLE = "img/workspacePlaceholderTable.svg"

export const CORRECTIVE_WORK_IMG = "img/icons/corrective_work.svg"
export const REGULAR_WORK_IMG = "img/icons/regular_work.svg"

export const IMG_PLACEHOLDER = "img/img-placeholder/imagePlaceholder.svg"
export const IMG_PLACEHOLDER_SM = "img/img-placeholder/imagePlaceholderSmall.svg"
export const IMG_UPLOAD_IN_PROGRESS_PLACEHOLDER = "img/img-placeholder/imageUploadInProgress.svg"
export const IMG_UPLOAD_FAILED_PLACEHOLDER = "img/img-placeholder/imageUploadFailed.svg"

export const IMG_MASCOT_SHRUG = "img/mascot/mascot-shrug.svg"
export const IMG_MASCOT_STOP = "img/mascot/mascot-stop.svg"
export const IMG_MASCOT_SURPRISED = "img/mascot/mascot-surprised.svg"
export const IMG_MASCOT_TECHNICIAN = "img/mascot/mascot-technician.svg"
export const IMG_MASCOT_TIME = "img/mascot/mascot-time.svg"
export const IMG_MASCOT_UNPLUG = "img/mascot/mascot-unplug.svg"

export const MOCK_USER_AVATAR =
  "https://img.freepik.com/free-vector/mysterious-mafia-man-smoking-cigarette_52683-34828.jpg?w=740&t=st=1690445741~exp=1690446341~hmac=28c40e626bb6c61c6c3a238dd3d4ca955a9fc5c287668be489dd89ede501129e"

export const ATTACHMENT_CONTEXT_LIST = [
  "item",
  "item_model",
  "corrective_work_area",
  "corrective_work_item",
  "corrective_work_item_comment",
  "regular_work_area",
  "regular_work_item",
  "regular_work_item_comment",
  "issue_area",
  "issue_item",
  "issue_item_comment",
  "work_order_corrective_item",
  "work_order_corrective_area",
  "work_order_corrective_item_comment",
  "work_order_corrective_area_comment",
  "work_order_regular_item",
  "work_order_regular_area",
  "work_order_regular_item_comment",
  "work_order_regular_area_comment",
  "area",
  "zone",
] as const
